import { createTheme } from '@mui/material';

export const BP_COLOR = {
  2: '#ab005650',
  5: '#ab0056',
  10: '#7A003D',
  20: '#660033',
  30: '#582d37',
  40: '#F1E4E7',
  solid_grey: 'rgb(0, 0, 0, 0.05)',
};

export const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          margin: 2,
          color: '#fff',
          textTransform: 'capitalize',
          paddingBlock: 9,
          borderRadius: 5,
          fontSize: '1rem',
          minWidth: '10rem',
          backgroundColor: BP_COLOR[5],
          '&:hover': {
            background: BP_COLOR[10],
          },
          '&:disabled': {
            background: BP_COLOR['solid_grey'],
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: BP_COLOR[5],
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          minWidth: 300,
          marginBlock: 5,
        }
      }
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          paddingInline: 15,
          paddingTop: 0
        }
      }
    },
  },
});
